// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-195f771d]{display:none}.wrapper[data-v-195f771d]{padding:0 16px 48px}@media(min-width:1024px){.wrapper[data-v-195f771d]{padding:0 0 48px}}.wrapper.is-last[data-v-195f771d]{padding-bottom:0}.wrapper.bg-beige[data-v-195f771d]{padding:0 16px 48px}@media(min-width:1024px){.wrapper.bg-beige[data-v-195f771d]{padding:0 0 48px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
